import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const TocTitle = styled.h2`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 20px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  margin: 0 0 ${barnesTheme.spacing.contentGap} 0;
  padding-bottom: ${barnesTheme.spacing.contentGap};
  border-bottom: 1px solid ${barnesTheme.colors.border};

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: 20px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    margin: 0 0 ${barnesTheme.spacing.contentGap} 0 !important;
    padding-bottom: ${barnesTheme.spacing.contentGap} !important;
    border-bottom: 1px solid ${barnesTheme.colors.border} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EntriesList = styled.div`
  display: flex;
  flex-direction: column;

  @media print {
    display: flex !important;
    flex-direction: column !important;
  }
`

export const EntryRow = styled.div`
  display: flex;
  align-items: baseline;
  padding: 10px 0;
  border-bottom: 1px solid ${barnesTheme.colors.border};
  gap: 18px;

  @media print {
    display: flex !important;
    align-items: baseline !important;
    padding: 10px 0 !important;
    border-bottom: 1px solid ${barnesTheme.colors.border} !important;
    gap: 18px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EntryNumber = styled.span`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 19px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  min-width: 42px;
  flex-shrink: 0;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: 19px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    min-width: 42px !important;
    flex-shrink: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EntryTitle = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: 13px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.text};
  flex: 1;

  @media print {
    font-family: ${barnesTheme.fonts.body} !important;
    font-size: 13px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.text} !important;
    flex: 1 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DottedLeader = styled.span`
  display: none;

  @media print {
    display: none !important;
  }
`

export const EntryPageNumber = styled.span`
  display: none;

  @media print {
    display: none !important;
  }
`
